<template>
  <v-container class="page-content-wrapper pt-0 px-sm-3">
    <h1 class="headline pa-3 px-sm-5">{{ $t("emailTemplates") }}</h1>
    <v-card class="flex-grow-1 d-flex flex-column">
      <email-templates-overview
        v-if="!showMailEditor"
        :user-has-admin-rights="userHasAdminRights"
        @edit-template="editTemplate($event)"
      ></email-templates-overview>
      <template-editor
        v-else
        :selected-template="selectedTemplate"
        :design="design"
        :plain-text="plainText"
        :preview-html="previewHtml"
        :user-has-admin-rights="userHasAdminRights"
        @close-preview="resetPage"
        @update:plain-text="plainText = $event"
        @close-editor="closeEditor"
        @save-template="saveTemplate"
      ></template-editor>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { axiosGet, axiosPost } from "@/api/requests";
import handleErrorStatus from "@/mixins/handleErrorStatus";
import snackBarMessages from "@/mixins/snackBarMessages";
import permissions from "@/mixins/permissions";
import TemplateEditor from "./TemplateEditor";
import EmailTemplatesOverview from "./EmailTemplatesOverview";
import b64helpers from "@/helpers/b64Helpers";

export default {
  title: "emailTemplates",
  name: "EmailTemplates",
  components: { EmailTemplatesOverview, TemplateEditor },
  mixins: [snackBarMessages, handleErrorStatus, permissions],
  data() {
    return {
      selectedTemplate: null,
      design: null,
      showMailEditor: false,
      plainText: "",
      previewHtml: "",
    };
  },
  computed: {
    ...mapState(["currentHotel", "user", "connection"]),
  },
  methods: {
    editTemplate(item) {
      this.selectedTemplate = item;
      this.loadTemplate(item);
    },
    loadTemplate(selected) {
      this.$root.$loader.open(this.$t("loadingTemplate"));
      const url =
        process.env.VUE_APP_DATA_URL +
        "/hotel/template?" +
        "name=" +
        this.connection.code +
        "&hotelcode=" +
        this.currentHotel.hotelCode +
        "&template=" +
        selected.name +
        "&templatetype=" +
        selected.templateType +
        "&locale=" +
        selected.locale;
      axiosGet(url, this.user.authToken)
        .then((response) => {
          this.handleLoadTemplateResponse(response);
        })
        .catch((error) => {
          console.log(error);
          this.snackbarError(this.$t("loadingTemplateFailed"));
        })
        .finally(() => {
          this.$root.$loader.close();
        });
    },
    handleLoadTemplateResponse(response) {
      if (response.status && response.status !== 200) {
        this.handleErrorStatus(response.status);
      } else if (response.success) {
        const templateData = JSON.parse(
          JSON.parse(b64helpers.b64DecodeUnicode(response.template))
        );
        const design = templateData.design;
        const plainText = templateData.plainText;
        this.design = design;
        this.previewHtml = templateData.html;
        this.plainText = plainText ? plainText : "";
        this.showMailEditor = true;
      } else if (response.template === "") {
        this.snackbarError(this.$t("noTemplateFound"));
      } else {
        this.snackbarError(this.$t("loadingTemplateFailed"));
      }
    },
    saveTemplate(base64Data) {
      this.$root.$loader.open(this.$t("saving"));
      const url = process.env.VUE_APP_DATA_URL + "/hotel/template/";
      const data = {
        Environment: this.connection.code,
        HotelCode: this.currentHotel.hotelCode,
        Template: {
          Name: this.selectedTemplate.name,
          TemplateType: this.selectedTemplate.templateType,
          Locale: this.selectedTemplate.locale,
          Template: base64Data,
        },
      };
      axiosPost(url, data, this.user.authToken)
        .then((response) => {
          this.handleSaveTemplateResponse(response);
        })
        .catch((error) => {
          console.log(error);
          this.snackbarError(this.$t("saveChangesFailed"));
        })
        .finally(() => {
          this.$root.$loader.close();
        });
    },
    handleSaveTemplateResponse(response) {
      if (response.status && response.status !== 200) {
        this.handleErrorStatus(response.status);
      } else if (response.error) {
        this.snackbarError(this.$t("saveChangesFailed"));
      } else if (response === true) {
        this.snackbarSucces(this.$t("saveChangesSuccess"));
        this.resetPage();
      } else {
        this.snackbarError(this.$t("saveChangesFailed"));
      }
    },
    closeEditor() {
      this.$root
        .$confirm(this.$t("closeEditor"), this.$t("closeEditorMessage"))
        .then((confirmResult) => {
          if (confirmResult) {
            this.resetPage();
          }
        });
    },
    resetPage() {
      this.design = null;
      this.selectedTemplate = null;
      this.showMailEditor = false;
    },
  },
};
</script>
